<template>
    <div class='ImageUpload row' :class='classObj'>
        <div class = 'SavedImage col-6'>
            <img :src='(source == "" || source == null) ? placeholder : source' :alt='altText' />
        </div>
        <div class='uploadUi col-6'>
        <label for="file-upload" class="custom-file-upload">
            Select Image
        </label>
        <input id="file-upload" type='file' accept="image/*" class='form-control-file' @change='Images_onFileChanged' @click='validate' />
        </div>
    </div>
</template>

<script>

    export default{
        name: 'ImageUpload',
        props: ['imageSrc', 'imageDesc', 'store', 'name', 'label'],
        data(){
            return{
                validationMessages: [],
                isFocused: false,
                altText: this.$props.imageDesc
            }
        },
        
        computed:{
            source:{
                get(){
                    return this.$store.getters[this.$props.store + '/' + this.$props.name]; },
                set (value) { 
                    return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) 
                    },
            },
            classObj(){
                return {
                    ImageUpload: true,
                    'has-error': this.valid == false || this.$props.hasErrors == true,
                    'has-success': this.valid == true,
                    'is-disabled': this.isDisabled == true,
                    'is-focused': this.isFocused == true
                }
            },
            getKey(){ return this.$props.store + '_' + this.$props.name },
            isDisabled() { return this.$props.disabled || false },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            validationMessage() { return this.validationMessages.join(', ') },
            placeholder() { return this.$props.imageSrc || '/images/no-image.png' }
        },
        methods:{ 
           Images_onFileChanged (e) {
               var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                this.createImage(files[0])
            },
           createImage(file) {
                var reader = new FileReader()
                var vm = this

                reader.onload = (e) => {
                    this.source = e.target.result
                }
                reader.readAsDataURL(file)
            },
            removeImage: function (e) {
                this.userImage = ''
            },
            returnToPage(){
                this.isFocused = false;
            },
            validate(e){
                console.log('validate - ' + e.type);
                if(e.type == 'click') {
                    this.isFocused = true;
                    document.body.onfocus = this.returnToPage;
                }
                //if(e.type == 'blur') this.isFocused = false;
                this.validationMessages = [];
                var rules = this.$props.validationRules || [];
                if(e.target.checkValidity() == false)
                    this.validationMessages.push('Please enter a valid value')
                else{
                    rules.forEach(rule => {
                        switch(rule){
                            case 'required':
                                if(!e.target.value)
                                this.validationMessages.push('This field is required')
                            break;
                        }
                    });
                }

                this.$emit('validate-field', { field: this.$props.name, status: this.valid})
            },
        }
    }

</script>